/**********************************************************************************
CHID       WHO         WHEN            WHY
********************************************************************************
CHID-1     Mahesh        23/11/2020      3603: Translate opening hour text to French
*********************************************************************************/
import { Component, Link } from "@mna/react";
import Modal from "@mna/react-ui/Modal";
import IconX from "assets/icons/x.svg";
import { Trans } from "react-i18next";
import {checkAndGetLocalStorageValue, checkAndGetSessionStorageValue} from "../../features/utils";

export default class ClinicModalProvider extends Component {
  state = {
    showModal: false,
    currentItem: 0,
  };

  componentDidMount() {
    Modal.setAppElement("#root");
  }

  openModal = ({ currentItem }) =>
    this.setState({
      showModal: true,
      currentItem,
    });

  closeModal = () =>
    this.setState({
      showModal: false,
    });

  render() {
    const { clinics = [], actions = {}, children, history, state } = this.props;
    const index = this.state.currentItem;
    const clinic = clinics[index] || {};
    const {
      name,
      phone,
      email,
      website,
      websiteDomain,
      todaysHours = "",
      line_1,
      distance = 0,
      distanceUnit = "km",
    } = clinic;
    const actionProps = { index, clinic, closeModal: this.closeModal };
    let mile = distance * 0.621371;
    let miles = mile.toFixed(2);
    return (
      <>
        <Modal
          contentLabel="Clinic Details"
          isOpen={this.state.showModal}
          onRequestClose={this.closeModal}
          className="ReactModal__Content single-clinic-modal selected-facilityContainer"
          overlayClassName="ReactModal__Overlay"
          role=""
        >
          <h2 className="mt-0 mb-1" tabIndex="0" aria-label={name} 
          >{name}</h2>
          <p tabIndex="0">
            <b>
              <Trans i18nKey="findcareoption.Careoptions.Address">
                Address
              </Trans>
              :
            </b>{" "}
            {line_1}
          </p>
          <p tabIndex="0">
            <span className="pr-2">
              <b>
                <Trans i18nKey="findcareoption.Careoptions.Distance">
                  Distance
                </Trans>
                :
              </b>{" "}
              {`${distance.toFixed(2)} ${distanceUnit} ${" / "} ${miles} ${"Mi"}`}
            </span>{" "}
          </p>
          {todaysHours === "n" ? null :
            <p tabIndex="0">
              {" "}
              <span>
                <b>
                  <Trans i18nKey="findcareoption.Careoptions.Hours">Hours</Trans>:
                </b>{" "}
                {todaysHours}
              </span>
            </p>
          }
          {!phone ? null : (
            <p tabIndex="0">
              <b>
                <Trans i18nKey="findcareoption.Careoptions.Phone">Phone</Trans>:
              </b>{" "}
              <Link to={`tel:${phone}`}>{phone}</Link>
            </p>
          )}
          {!email ? null : (
            <p tabIndex="0">
              <b>
                <Trans i18nKey="findcareoption.Careoptions.Email">Email</Trans>:
              </b>{" "}
              {email}
            </p>
          )}
          {!website ? null : (
            <p tabIndex="0">
              <b>
                <Trans i18nKey="findcareoption.Careoptions.Website">
                  Website
                </Trans>
                :
              </b>{" "}
              <Link to={website}>{websiteDomain || website}</Link>
            </p>
          )}
          <button type="button"
            className="button standby-button standby-button-gradient standby-button-gradient-green standby-button-full-width"
            onClick={() => {
              if (checkAndGetSessionStorageValue("isTravelAid2") === "true" && checkAndGetLocalStorageValue("IsEmergencySelected") === "false" && !state.triageRequest.isFacilitySearch) {
                actions.updateLogPharmaciesData(actionProps)
                history.push("done");
              }
              else { 
                if(!state.triageRequest.data || !state.triageRequest.data.email){
                  state.phone = "";
                }
                actions.sendInformation(actionProps) 
              }
            }}
          >
            <Trans i18nKey="findcareoption.Careoptions.select">Select</Trans>
          </button>
          <button type="button" className="absolute top right mr-1 mt-1" onClick={this.closeModal}>
            <span
              className="icon cursor-pointer"
              style={{ width: "15px" }}
              aria-label="close"
            >
              <IconX />
            </span>
          </button>
        </Modal>
        {children &&
          children({
            openModal: this.openModal,
            closeModal: this.closeModal,
          })}
      </>
    );
  }
}
